import { gql } from 'graphql-tag'
import { SUBSCRIPTION_DETAILS_FIELDS, CHAT_FIELDS, EXT_BOOKING_FIELDS, EXT_CLIENT_FIELDS, EXTERNAL_REVIEW_FIELDS, PRIVATE_PAYMENT_FIELDS } from '../graph/definition/fragments'

class Listeners {
  bookingUpdated = gql`
    subscription($userId: String) {
      bookingUpdated(userId: $userId) {
        booking {
          _id
          status
          professionalId
        }
      }
    }
  `

  externalBookingUpdated = gql`
    ${EXT_BOOKING_FIELDS}
    ${EXTERNAL_REVIEW_FIELDS}
    ${EXT_CLIENT_FIELDS}
    ${PRIVATE_PAYMENT_FIELDS}
    subscription($userId: String) {
      externalBookingUpdated(userId: $userId) {
        externalBooking {
          ...ExternalBookingFields
        }
        previousDate
        previousAllocatedProfessionalId
      }
    }
  `

  // Days to refetch for the members a calendar is showing. The API only honours the ids this
  // session is allowed to watch, whatever is asked for.
  calendarUpdated = gql`
    subscription($memberIds: [String!]!) {
      calendarUpdated(memberIds: $memberIds) {
        memberIds
        dates
        weekdays
      }
    }
  `

  chatUpdated = gql`
    ${CHAT_FIELDS}
    subscription($userId: String!) {
      chatUpdated(userId: $userId) {
        chat {
          ...ChatFields
        }
        professionalUnreads
      }
    }
  `

  userUpdated = gql`
    ${SUBSCRIPTION_DETAILS_FIELDS}
    subscription($userId: String!) {
      userUpdated(userId: $userId) {
        userId
        stripeAccountStatus
        stripePayoutEnabled
        stripePayoutInterval
        stripeCapabilities {
          transfers
          card_payments
        }
        subscriptionDetails {
          ...SubscriptionDetailsFields
        }
      }
    }
  `

  salonMemberUpdated = gql`
    subscription {
      salonMemberUpdated {
        _id
        salonId
        memberId
        color
        displayName
        picture
        title
        permissions
        status
        createdAt
        updatedAt
      }
    }
  `
}

const listeners = new Listeners()
export default listeners
